import { uniqueLength } from './util'
import formatDelay from '@/module/util/format-delay'

export default {
    getEventCards: (state) => (event) => {
        if(state.event) {
            const eventAction = state.event[event.id]
            if(eventAction && eventAction[event.id]) {
                const eventBody = eventAction[event.id]
                const all = eventAction.patients.length
                const opened = uniqueLength(eventBody.flatMap(message => message.opened ? message.opened : []))
                const gotit = uniqueLength(eventBody.flatMap(message => message.accepted ? message.accepted : []))
                const learnmore = uniqueLength(eventBody.flatMap(message => message.action ? message.action : []))
                const noaction = all - uniqueLength(eventBody.flatMap(message => {
                    let sumArr = message.action ? message.action : []
                    sumArr = sumArr.concat(message.accepted ? message.accepted : [])
                    sumArr = sumArr.concat(message.opened ? message.opened : [])
                    return sumArr
                }))
                return {
                    all,
                    opened,
                    gotit,
                    learnmore,
                    noaction
                }
            }
            return {}
        }
        return {}
    },
    getMessageList: (state) => (event) => {
        if(state.event) {
            const eventAction = state.event[event.id]
            if(eventAction && eventAction[event.id]) {
                const eventBody = eventAction[event.id]
                return eventBody.map(message => {
                    return {id: message.id, title: message.title, delayTitle: formatDelay(message.delay)}
                })
            }
            return []
        }
        else {
            return []
        }
    },
    getPatientData: (state) => (event) => {
        if(state.event) {
            const eventData = state.event[event.id]
            if(eventData && eventData.patients && eventData[event.id]) {
                let patientAction = eventData.patients.reduce((acc, patient) => {
                    acc[patient.id] = {
                        ...patient,
                        ...eventData[event.id].reduce((messageAcc, message) => ({
                            ...messageAcc,
                            [message.id]: (new Array(patient.events[event.id])).fill({})
                        }), {})
                    }
                    return acc
                }, {})

                patientAction = eventData[event.id].reduce((acc, message) => {
                    if(message.accepted) {
                        message.opened = [...message.accepted, ...message.opened]
                        message.accepted.forEach(({user, instance}) => acc[user][message.id][instance - 1]['accepted'] = true)
                    }
                    if(message.opened) {
                        message.opened.forEach(({user, instance}) => {acc[user][message.id][instance - 1]['opened'] = true})
                    }
                    if(message.action) {
                        message.action.forEach(({user, instance}) => acc[user][message.id][instance - 1]['action'] = true)
                    }
                    return acc
                }, patientAction)
                eventData.patientAction = Object.values(patientAction)
                return eventData.patientAction
            }
            return []
        }
        else {
            return []
        }
    }
}
